import React, { FC } from 'react'
import icon from '@images/diya.svg'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

interface IVerificationBadge {
  className?: string
  verified?: boolean
}

// Off by default: a forgotten prop used to show "Верифіковано!" to every
// signed-in user in the header menu. Diia's mark is white, so the pill is
// dark in both themes (white 12px text on the old green read at 3.6:1).
const VerificationBadge: FC<IVerificationBadge> = ({ className, verified = false }) => {
  const { t } = useTranslation()

  // Don't render if not verified
  if (!verified) return null

  return (
    <div
      className={clsx(
        'flex justify-between items-center self-stretch py-1.5 px-4 w-full text-xs font-bold text-center text-white bg-inverse rounded-full',
        className,
      )}
    >
      <div className="w-[1.3125rem] h-3 flex-shrink-0">
        <img src={icon} alt="" className="object-contain size-full" />
      </div>

      <div className="flex-1 shrink my-auto basis-0 break-words min-w-0">{t('verified')}!</div>
    </div>
  )
}

export default VerificationBadge
